import { Container, Input } from '@descope/page-editor-components';
import { Box } from '@mui/material';
import React from 'react';
import TypographyFontFamilyAutocomplete from './TypographyFontFamilyAutocomplete';

type Props = {
	fontFamilies: string[];
	values: Record<string, string>;
	setVariant: (path: string, value: string) => void;
};

export default ({ fontFamilies, values, setVariant }: Props) => (
	<Box paddingY={2} paddingX={4} sx={{ '& > *': { marginBottom: 3 } }}>
		<TypographyFontFamilyAutocomplete
			fontFamilies={fontFamilies}
			values={values}
			setVariant={setVariant}
		/>
		<Container>
			<Input readOnly value="Input" />
		</Container>
	</Box>
);
